import styled from "styled-components";

export const SenasaRestrictedCodesContainer = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => margin ?? ""};
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody + theme.transparencies.p30};
  `}
  font-size: 1.4rem;
  font-weight: 700;
`;

export const ULRestrictedCodes = styled.ul`
  overflow-y: auto;
  max-height: 30vh;
  list-style-type: none;
  margin: 1rem 0;
  padding: 0;
  font-family: Montserrat;
  font-size: 1.5rem;
  font-style: normal;
  line-height: 3rem;
`;

export const LiRestricedCode = styled.li`
  list-style-type: none;
  margin-left: 0;
  padding-left: 0;
`;
